import actions from "~/shared/actions/log";

export function empty() {
	return (dispatch) => dispatch(actions.emptyLog());
}
